const jQuery = $;

/* contact forms 7 validation */

$(document).on("click", '.popup-close', (e) => {
    $(e.currentTarget).closest(".cf7-popup").stop(true, true).fadeOut(500);
});


document.addEventListener('wpcf7submit', function (event) {
    if (event.detail.apiResponse.status !== 'mail_sent') {
        return;
    }

    const formID = event.detail.contactFormId;

    const defaultPopup = $('.cf7-popup');
    const customPopup = defaultPopup.filter(p => $(p).data('id') == formID);

    if (customPopup.length) {
        customPopup.fadeIn()
    } else {
        defaultPopup.fadeIn();
    }

}, false);